import { useCallback } from 'react'
import { ToastBar, Toaster as ToasterHot } from 'react-hot-toast'

import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined'

import { alpha, useTheme } from '@mui/material/styles'

export default function Toaster() {
  const theme = useTheme()

  // Defines the custom toast styles
  const toastCustomStyle = useCallback(
    (toastType, styles) => {
      // Default
      if (toastType === 'blank') {
        return {
          ...styles,
          ...{
            color: theme.palette.primary.contrastText,
            background: alpha(theme.palette.primary.main, 0.8),
          },
        }
      }

      // Warning
      if (toastType === 'warn') {
        return {
          ...styles,
          ...{
            color: theme.palette.warning.contrastText,
            background: alpha(theme.palette.warning.main, 0.9),
          },
        }
      }

      // Error
      return {
        ...styles,
        ...{
          color: theme.palette.error.contrastText,
          background: alpha(theme.palette.error.main, 0.9),
        },
      }
    },
    [theme]
  )
  const toastCustomIcon = useCallback((toast) => {
    if ('warn' === toast.type && !toast?.icon) {
      toast.icon = <ExclamationCircleOutlined />
    }

    return toast
  }, [])

  return (
    <ToasterHot
      position="top-center"
      toastOptions={{
        duration: 5000,
        style: {
          fontSize: '1rem',
          fontWeight: 700,
          fontFamily: theme.typography.fontFamily,
          backdropFilter: `blur(${theme.spacing(1)})`,
          WebkitBackdropFilter: `blur(${theme.spacing(1)})`,
        },
        error: toastCustomStyle,
        success: {
          style: {
            color: theme.palette.primary.contrastText,
            background: alpha(theme.palette.success.main, 0.9),
          },
        },
      }}
    >
      {(t) => {
        return <ToastBar toast={toastCustomIcon(t)} style={toastCustomStyle(t.type, t.style)} />
      }}
    </ToasterHot>
  )
}
